export default {"src":"/_next/static/media/kvmCompatible.6fcefcd9.svg","height":29,"width":28};